import { Stack, Table, TableContainer, Tbody, Td, Tr } from '@chakra-ui/react';
import React from 'react';

export const PartTables = () => {
  return (
    <Stack textAlign={'left'} py={8} align={'start'} w='full' maxW={'6xl'}>
      <TableContainer whiteSpace={'wrap' as any}>
        <Table>
          <Tbody fontSize={{ base: 12, md: 14 }}>
            <Tr>
              <Td>Part</Td>
              <Td>Designation</Td>
              <Td>This part is for you...</Td>
            </Tr>
            <Tr>
              <Td>Part A</Td>
              <Td>General</Td>
              <Td>...always relevant.</Td>
            </Tr>
            <Tr>
              <Td>Part B</Td>
              <Td>Website and social media presences</Td>
              <Td>
                ...relevant if you use our website, including our social media
                presence.
              </Td>
            </Tr>
          </Tbody>
        </Table>
      </TableContainer>
    </Stack>
  );
};
